export enum I18Enum {
    EN = 'en',
    KR = 'kr'
}